import { finalize, first, switchMap, take, tap } from 'rxjs/operators';
// eslint-disable-next-line max-len
// import { AddPromotionCodeDialogComponent } from '../../../promotion-coupons/components/add-promotion-code-dialog/add-promotion-code-dialog.component';
import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { DialogService } from 'src/app/core/services/dialog.service';
import { PromotionCouponsService } from 'src/app/promotion-coupons/services/promotion-coupons.service';
import { PaymentWithCouponData } from 'src/app/pay/models/payment-with-coupon-data.model';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { CustomerCoupon } from 'src/app/promotion-coupons/models/customer-coupon.model';
import { PaymentStatus } from 'src/app/pay/models/payment-status.model';
import { AvailableCoupon } from '../../models/available-coupon.model';
import { PaymentService } from '../../../pay/services/payment.service';
import { AnalyticsEvent, AnalyticsService } from '../../../core/services/analytics-service';
import { Router } from '@angular/router';
import { SelectedCoupon } from '../../models/selected-coupon.model';
import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { AppConfig } from '../../../core/services/app-config.service';

@Component({
standalone: false,
  selector: 'app-coupon-select',
  styleUrls: ['./coupon-select.component.scss'],
  templateUrl: './coupon-select.component.html',
})
export class CouponSelectComponent implements OnChanges {
  @Input() paymentData: PaymentWithCouponData;
  @Input() paymentCoupon: SelectedCoupon;
  @Input() emptyCartCouponId: string;

  @ViewChild(CdkConnectedOverlay) cdkConnectedOverlay: CdkConnectedOverlay;
  selectedCoupon: SelectedCoupon;

  public visible = false;
  public loading = false;
  public loadingCouponId: string | 'no_coupon' | undefined;
  public clickDisabled = false;
  public coupons$: BehaviorSubject<AvailableCoupon[]> = new BehaviorSubject([]);

  public PaymentStatus = PaymentStatus;

  constructor(
    private dialogService: DialogService,
    private promotionCouponsService: PromotionCouponsService,
    private paymentService: PaymentService,
    private analyticsService: AnalyticsService,
    private router: Router,
    public appConfig: AppConfig,
  ) {
    this.coupons$.pipe(first((coupon) => !!(coupon && coupon?.length > 0))).subscribe(() => {
      //refresh overlay after coupons are loaded
      setTimeout(
        () =>
          this.cdkConnectedOverlay &&
          this.cdkConnectedOverlay.overlayRef &&
          this.cdkConnectedOverlay.overlayRef.updatePosition(),
      );
    });
  }

  public ngOnChanges(changes: SimpleChanges) {
    const paymentCouponChanged = changes.paymentCoupon?.currentValue !== changes.paymentCoupon?.previousValue;
    const emptyCartCouponIdChanged =
      changes.emptyCartCouponId?.currentValue !== changes.emptyCartCouponId?.previousValue;

    if (paymentCouponChanged && !!this.paymentCoupon) {
      this.selectedCoupon = this.paymentCoupon;
    } else if (emptyCartCouponIdChanged && !!this.emptyCartCouponId) {
      (this.coupons$.value.length ? of(this.coupons$.value.length) : this.loadCoupons()).subscribe(
        () => (this.selectedCoupon = this.coupons$.value.find((coupon) => coupon.couponId === this.emptyCartCouponId)),
      );
    } else if (paymentCouponChanged || emptyCartCouponIdChanged) {
      this.selectedCoupon = null;
    }
  }

  public toggleCouponsList() {
    this.visible = !this.visible;

    if (this.visible && !this.coupons$.value.length) {
      this.loadCoupons().subscribe();
    }
  }

  public addPromoCode(): void {
    this.closeMenu();
    // this.dialogService.open(AddPromotionCodeDialogComponent, {
    //   data: {
    //     paymentId: this.paymentData.paymentId,
    //   },
    // });
  }

  public closeMenu(): void {
    this.visible = false;
  }

  public changeCoupon(couponId: string): void {
    if (this.paymentData.paymentId) {
      this.clickDisabled = true;
      this.paymentService
        .changeCoupon(this.paymentData.paymentId, couponId)
        .pipe(
          switchMap((paymentId: string) => this.navigateToNewPayment(paymentId)),
          take(1),
        )
        .subscribe(() => this.analyticsService.trackEvent(new AnalyticsEvent('Change payment coupon', { couponId })));
    } else {
      this.router.navigate(['/liabilities/pay'], {
        queryParams: { emptyCartCouponId: couponId },
        queryParamsHandling: 'merge',
      });
      this.closeMenu();
    }
  }

  public removeCoupon(): void {
    if (this.paymentData.paymentId) {
      this.clickDisabled = true;
      this.paymentService
        .removeCoupon(this.paymentData.paymentId)
        .pipe(
          switchMap((paymentId: string) => this.navigateToNewPayment(paymentId)),
          take(1),
        )
        .subscribe(() =>
          this.analyticsService.trackEvent(
            new AnalyticsEvent('Remove coupon', { paymentId: this.paymentData.paymentId }),
          ),
        );
    } else {
      this.router.navigate(['/liabilities/pay'], {
        queryParams: { emptyCartCouponId: '' },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
      this.closeMenu();
    }
  }

  private navigateToNewPayment(paymentId: string): Promise<boolean> {
    return this.router.navigate(['/liabilities/pay', paymentId]);
  }

  private loadCoupons(): Observable<any> {
    this.loading = true;
    return this.promotionCouponsService.getAvailableCouponsForCustomer().pipe(
      tap((coupons: CustomerCoupon[]) => this.coupons$.next(coupons)),
      take(1),
      finalize(() => (this.loading = false)),
    );
  }
}
